// contexts/SpotlightContext.ts
import { createContext, useContext } from 'react';
import type { WidgetHelpData } from '@/types/dashboard';

export interface SpotlightContextValue {
    activeWidgetId: string | null;
    helpData: WidgetHelpData | null;
    anchorEl: HTMLElement | null;
    openSpotlight: (widgetId: string, helpData: WidgetHelpData, anchorEl: HTMLElement) => void;
    closeSpotlight: () => void;
}

export const SpotlightContext = createContext<SpotlightContextValue | null>(null);

export const useSpotlight = (): SpotlightContextValue => {
    const context = useContext(SpotlightContext);
    if (context === null) {
        throw new Error('useSpotlight must be used within a SpotlightProvider');
    }
    return context;
};
